const selectionReducer = (state, action) => {
    switch (action.type) {
        case "TOGGLE":
            return {
                ...state,
                [action.payload]: !state[action.payload]
            }
        case "TOGGLE_ALL":
            const newState = action.payload.ids.reduce((s, id) => ({ ...s, [id]: action.payload.value }), {})
            return {
                ...state,
                ...newState,
            }
        case "RESET":
            return {};
        default:
            return state;
    }
}

export default selectionReducer;